module.exports = __webpack_public_path__ + "img/lang-de.d65f95ac.png";